import type { BrowserLogger } from '../logger.js';
import { normalizeTemporalInputValue } from './date-input.js';

export type TemporalInputFillContext = {
  ref: string;
  action: 'typing' | 'filling';
};

export type TemporalInputFillValue = {
  inputType: string | null;
  value: string;
  shouldFillDirectly: boolean;
};

export type TemporalInputLocator = {
  evaluate(pageFunction: (node: Element) => string | null): Promise<string | null>;
};

export function isNativeTemporalInputType(
  inputType: string | null
): inputType is 'date' | 'datetime-local' {
  return inputType === 'date' || inputType === 'datetime-local';
}

export async function resolveTemporalInputFillValue(
  locator: TemporalInputLocator,
  value: string,
  context: TemporalInputFillContext,
  logger: BrowserLogger
): Promise<TemporalInputFillValue> {
  const inputType = await locator
    .evaluate((node) => (node instanceof HTMLInputElement ? node.type : null))
    .catch((err) => {
      logger.debug(`[DirectPlaywright] Failed to inspect input type before ${context.action}`, {
        ref: context.ref,
        error: err instanceof Error ? err.message : String(err),
      });
      return null;
    });

  return {
    inputType,
    value: normalizeTemporalInputValue(value, inputType),
    shouldFillDirectly: isNativeTemporalInputType(inputType),
  };
}
